import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";

interface SessionTimeoutDialogProps {
  open: boolean;
  secondsRemaining: number;
  onStayActive: () => void;
  onSignOut: () => void;
}

/** Warning shown during the countdown before an idle session expires. */
export function SessionTimeoutDialog({
  open,
  secondsRemaining,
  onStayActive,
  onSignOut,
}: SessionTimeoutDialogProps) {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="session-timeout-title"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-overlay/40 p-4"
    >
      <div className="flex w-full max-w-sm flex-col gap-4 rounded-lg border border-border bg-bg-elevated p-6 shadow-lg">
        <div className="flex flex-col gap-1">
          <h2
            id="session-timeout-title"
            className="text-base font-semibold text-text-primary"
          >
            {t("common:sessionTimeout.warningTitle")}
          </h2>
          <p className="text-sm text-text-muted">
            {t("common:sessionTimeout.warningDescription")}
          </p>
        </div>
        <p className="text-sm font-medium text-text-primary">
          {t("common:sessionTimeout.secondsRemaining", { count: secondsRemaining })}
        </p>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onSignOut}>
            {t("common:sessionTimeout.signOut")}
          </Button>
          <Button variant="primary" onClick={onStayActive}>
            {t("common:sessionTimeout.stayActive")}
          </Button>
        </div>
      </div>
    </div>
  );
}
